import { useBoolean } from 'ahooks';
import { useUserLoggedIn } from '~/modules/user';
import LoginSignUpModal from '~/modules/user/component/login-signup-modal/LoginSignUpModal';

interface Props {
    selectedVariant: {
        TradeOnlyEnabled: boolean;
        TradePrice?: {
            Amount: number;
        } | null;
    } | null;
}
const TradeOnlyBanner = ({ selectedVariant }: Props) => {
    const { isLoggedIn } = useUserLoggedIn();
    const [showSignIn, setShowSignIn] = useBoolean(false);

    if (
        isLoggedIn ||
        !selectedVariant?.TradeOnlyEnabled ||
        !selectedVariant?.TradePrice?.Amount
    ) {
        return null;
    }

    return (
        <>
            <div className="bg-gray-100 p-3 text-center text-sm md:p-4 md:text-base">
                <button
                    type="button"
                    className="cursor-pointer underline"
                    onClick={setShowSignIn.setTrue}
                >
                    Sign in as a professional
                </button>{' '}
                to purchase trade only products
            </div>
            <LoginSignUpModal
                login={{
                    open: showSignIn,
                    onCancel: setShowSignIn.setFalse,
                    onConfirm: setShowSignIn.setFalse,
                    onAuthSuccess: setShowSignIn.setFalse,
                    flow: null,
                    authSource: 'tradeOnlyBanner',
                }}
                forgotPassword={{
                    open: showSignIn,
                    onCancel: setShowSignIn.setFalse,
                }}
            />
        </>
    );
};

export default TradeOnlyBanner;
